import { css } from '@emotion/react';


export default ($) => css`
  @keyframes spinner-border {
    to {
      transform: rotate(360deg);
    }
  }

  .spinner-border {
    display: inline-block;
    width: ${$.spinnerWidth};
    height: ${$.spinnerHeight};
    vertical-align: ${$.spinnerVerticalAlign};
    border: ${$.spinnerBorderWidth} solid currentColor;
    border-right-color: transparent;
    border-radius: 50%;
    animation: 0.75s linear infinite spinner-border;
  }

  .spinner-border-sm {
    width: ${$.spinnerWidthSm};
    height: ${$.spinnerHeightSm};
    border-width: ${$.spinnerBorderWidthSm};
  }

  @keyframes spinner-grow {
    0% {
      transform: scale(0);
    }
    50% {
      opacity: 1;
      transform: none;
    }
  }

  .spinner-grow {
    display: inline-block;
    width: ${$.spinnerWidth};
    height: ${$.spinnerHeight};
    vertical-align: ${$.spinnerVerticalAlign};
    background-color: currentColor;
    border-radius: 50%;
    opacity: 0;
    animation: 0.75s linear infinite spinner-grow;
  }

  .spinner-grow-sm {
    width: ${$.spinnerWidthSm};
    height: ${$.spinnerHeightSm};
  }

  ${$.enablePrefersReducedMotionMediaQuery && `
    @media (prefers-reduced-motion: reduce) {
      .spinner-border,
      .spinner-grow {
        animation-duration: 1.5s;
      }
    }
  `}
`;
